export const columnTypeData: { displayValue: string; value: string }[] = [
  { displayValue: 'Boolean', value: 'Boolean' },
  { displayValue: 'Date', value: 'Date' },
  { displayValue: 'Date and Time', value: 'Datetime' },
  { displayValue: 'Decimal', value: 'Decimal' },
  { displayValue: 'Dropdown', value: 'Dropdown' },
  { displayValue: 'Number', value: 'Number' },
  { displayValue: 'String', value: 'String' },
  { displayValue: 'Text', value: 'Text' }
];
